import styled from "styled-components";
import { Button, Grid } from "@material-ui/core";
import FormSimpleSelect from "@src/Components/Common/FormFields/FormSimpleSelect/FormSimpleSelect";

export const STMainWrapper = styled.div`
  && {    
    width: 100%
  }
`;

export const STGrid = styled(Grid)`
  && {    
    padding-right: 2em;
  }
`;

export const STButton = styled(Button)`
  && {
    margin-top: 0;
  }
`;
